import { DebugLog } from './debug-log';

export function ua() {
  let ua = window && navigator.userAgent.toLowerCase();
  if (window.OG_DEVICE_TYPE === 'desktop') {
    ua = 'desktop';
  }

  return ua || 'unknown';
}

export function getPlatform() {
  return (isIos() && 'IOS') || (isAndroid() && 'ANDROID') || 'WEB';
}

export function isAndroid() {
  return /android/i.test(ua());
}

export function isIos() {
  return (
    /iphone|ipad|ipod/i.test(ua()) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

export function isMobile() {
  return isAndroid() || isIos();
}

export function isInternal(name: string) {
  return name.toLowerCase() === 'ogury';
}

export function isMobileWeb() {
  return isWeb() && isMobile();
}

export function isWeb() {
  return Boolean(window && window.MRAID_ENV && window.MRAID_ENV.mwebFlag);
}

export function isPreloadingActivated(formatConfig: any) {
  return isWeb() && formatConfig.triggerImpressionAfterPreload;
}

export function getAndroidVersion() {
  const match = ua().match(/android\s?([0-9.]*)/);
  return match ? parseFloat(match[1]) : 0;
}

export function getStringAndroidVersion(): string {
  const version = getAndroidVersion();
  return version > 0 ? version.toString() : 'androidVersionUnknown';
}

export function getIosVersion() {
  const match = ua().match(/os ((\d+_?){2,5})\s/);
  return match && match[1] ? parseFloat(match[1].replace(/_/g, '.')) : 0;
}

export function getStringIosVersion(): string {
  const version = getIosVersion();
  return version > 0 ? version.toString() : 'iosVersionUnknown';
}

export function getSdkVersion() {
  return window.MRAID_ENV.sdkVersion || '';
}

export function isInternalSdk(): boolean {
  return Boolean(window.MRAID_ENV?.sdk?.toLowerCase() === 'presage');
}

export function isExternalSdk(): boolean {
  return !isInternalSdk();
}

export function isChromeBrowser(
  userAgent: string = navigator.userAgent
): boolean {
  return /\b(?:crmo|crios|Chrome)\/([\w.]+)/i.test(userAgent);
}

export function getBrowserVersion() {
  return isAndroid() ? getChromiumVersion() : getSafariVersion();
}

export function getChromiumVersion() {
  const match = ua().match(/chrom(e|ium)\/([0-9]+)\./);
  return match ? parseInt(match[2], 10) : 0;
}

export function getSafariVersion() {
  const match = ua().match(/safari\/([0-9]+)\./);
  return match ? parseInt(match[1], 10) : 0;
}

export function versionIsAboveOrEqual(
  currentVersion: string,
  targetVersion: string
): boolean {
  const versionNumberRegex = /^\d+(\.\d+)*/;
  if (
    !targetVersion ||
    !currentVersion ||
    !targetVersion.match(versionNumberRegex) ||
    !currentVersion.match(versionNumberRegex)
  ) {
    DebugLog.log(
      `versionIsAboveOrEqual(targetVersion, currentVersion): expects targetVersion and currentVersion to be formated the following way x.x.x`
    );
    return false;
  }

  // Clean versions from specific suffixes (-B, -C, -baidu...)
  const cleanedCurrentVersion = currentVersion.split('-')[0];
  const cleanedTargetVersion = targetVersion.split('-')[0];

  const targetVersionTokens = cleanedTargetVersion.split('.');
  const currentVersionTokens = cleanedCurrentVersion.split('.');
  const longestLength =
    targetVersionTokens.length > currentVersionTokens.length
      ? targetVersionTokens.length
      : currentVersionTokens.length;
  for (let i = 0; i < longestLength; i++) {
    if (
      targetVersionTokens[i] &&
      currentVersionTokens[i] &&
      targetVersionTokens[i] !== currentVersionTokens[i]
    ) {
      return (
        parseInt(targetVersionTokens[i]) <= parseInt(currentVersionTokens[i])
      );
    }
  }
  return true;
}

export function versionIsStrictlyAbove(
  currentVersion: string,
  targetVersion: string
) {
  return (
    currentVersion !== targetVersion &&
    versionIsAboveOrEqual(currentVersion, targetVersion)
  );
}

export function getOgAdContext(): OgAdContext {
  return window.OG_AD_CONTEXT || {};
}
